import { DynamicFormValue } from 'components/multiple-dynamic-form/multiple-dynamic-form.interface';

export interface SubmitFormInfo {
  formData: any;
  saveAsDraft?: boolean;
}

export interface DynamicFormInfoToSave {
  forms: DynamicFormValue[];
  saveAsDraft?: boolean;
  id: number;
  signature_link: string;
}

export const PAGES = {
  MAIN_START: 'MAIN_START',
  MAIN_COMPLETE: 'MAIN_COMPLETE',
  EVIDENCE_START: 'EVIDENCE_START',
  EVIDENCE_CONFIRM: 'EVIDENCE_CONFIRM',
  EVIDENCE_COMPLETE: 'EVIDENCE_COMPLETE',
  FORM_START: 'FORM_START',
  FORM_MULTIPLE_COMPLETE: 'FORM_MULTIPLE_COMPLETE',
  DRAFT: 'DRAFT',
  FORM_CONFIRM: 'FORM_CONFIRM',
  SIGNATURE: 'SIGNATURE',
  RESET_CONFIRM: 'RESET_CONFIRM',
  BACK: 'BACK',
};
